var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsMarkerCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 46,
    fill: "none",
    viewBox: "0 0 38 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#66C430",
    d: "M18.67 25.672a7.002 7.002 0 1 0 0-14.003 7.002 7.002 0 0 0 0 14.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#66C430",
    d: "M18.67 45.976c12.37-10.969 18.671-20.304 18.671-27.305A18.67 18.67 0 1 0 0 18.67c0 7.001 6.301 16.103 18.67 27.305Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.352 13.419c-1.079-3.487-3.516-6.002-5.888-7.346-4.952-2.74-8.64-1.432-8.505-1.43-.065.337 3.554-.536 8 2.224a12.386 12.386 0 0 1 4.42 4.906c.372 3.475-3.088 4.11-4.034 1.242-1.09-3.307-1.976-4.766-3.272-4.596-1.239.13-2.287 3.382-2.747 4.78-.46 1.398-1.592 5.427-2.44 7.246-.85 1.818-2.169 2.622-3.434 2.59-1.266-.03-2.275-.846-3.364-2.842-.36-.064-1.34-.226-1.34-.226.514 2.542 2.744 5.368 4.974 5.337 2.23-.03 3.334-1.505 4.506-4.654 1.172-3.148 2.085-6.4 4.126-6.473 1.643-.097 1.894 1.99 2.339 3.514.443 1.524 1.257 4.342 3.39 4.354.825 0 1.45-.512 1.912-1.192a11.811 11.811 0 0 1-1.553 3.065c-2.205 3.122-5.768 4.928-9.11 5.144-3.365.284-6.384-.83-8.428-2.322-4.177-3.118-4.666-6.72-4.937-6.549-.077-.117.021 3.707 4.355 7.29 2.119 1.703 5.391 3.04 9.1 2.796 3.687-.167 7.685-2.136 10.13-5.606 2.456-3.461 2.92-7.82 1.8-11.252Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsMarkerCenter);
export default __webpack_public_path__ + "static/media/maps-marker-center.63dcd49c632a81f35fa1ee3e3effc697.svg";
export { ForwardRef as ReactComponent };